// extracted by mini-css-extract-plugin
export var csatScore = "_iy-5";
export var header = "_iy-1";
export var panelWrapper = "_iy-2";
export var postPreview = "_iy-3";
export var rightContent = "_iy-0";
export var wrappingText = "_iy-4";